import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getMovieById } from "../utils/movieUtils";
import VideoPlayer from "../components/VideoPlayer";
import { getCurrentUser } from "../utils/auth";
import "../styles/styles.css";

const MovieDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [movie, setMovie] = useState(null);
  const user = getCurrentUser();

  useEffect(() => {
    const found = getMovieById(id);
    if (!found) {
      navigate("/movies");
    } else {
      setMovie(found);
    }
  }, [id, navigate]);

  if (!movie) return null;

  return (
    <div className="series-detail-container">
      <div className="detail-grid">
        <div className="thumbnail-container">
          <img
            src={movie.thumbnail}
            alt={`${movie.title} Thumbnail`}
            className="detail-thumbnail"
          />
        </div>
        <div className="detail-info">
          <h2 className="detail-title">{movie.title}</h2>
          <p className="detail-synopsis">{movie.synopsis}</p>
          <div className="detail-meta">
            <span>Duración: {movie.duration}</span>
            <span>Género: {movie.genre.join(", ")}</span>
            <span>Estreno: {movie.releaseDate}</span>
          </div>
        </div>
      </div>

      <div className="player-wrapper">
        <VideoPlayer videoUrl={movie.videoUrl} user={user} />
      </div>
    </div>
  );
};

export default MovieDetail;
